var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileChartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5.714,
  height: 8,
  x: 1,
  y: 6.857,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  d: "M3.857 6.857V3.43M3.857 18.286v-3.429"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 5.714,
  height: 8,
  x: 11.286,
  y: 3.429,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  d: "M14.143 3.429V0M14.143 14.857V11.43"
})));
export default SvgMobileChartIcon;